const tollerance = 50;

export function isInView(element) {
    let returnValue = false;
    if(element !== null){
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= - tollerance &&
            rect.bottom <= window.innerHeight +  tollerance*2
        );
    }
    return returnValue;
}